import { render, staticRenderFns } from "./Admissions.vue?vue&type=template&id=0c0f9772&"
import script from "./Admissions.vue?vue&type=script&lang=ts&"
export * from "./Admissions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports